/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingPersonContactsDto } from './traveline-booking-person-contacts-dto';
import {
    TravelineBookingPersonContactsDtoFromJSON,
    TravelineBookingPersonContactsDtoFromJSONTyped,
    TravelineBookingPersonContactsDtoToJSON,
    TravelineBookingPersonContactsDtoToJSONTyped,
} from './traveline-booking-person-contacts-dto';

/**
 * Customer entity
 * @export
 * @interface TravelineBookingCustomerDto
 */
export interface TravelineBookingCustomerDto {
    /**
     * Name
     * @type {string}
     * @memberof TravelineBookingCustomerDto
     */
    firstName: string;
    /**
     * Surname
     * @type {string}
     * @memberof TravelineBookingCustomerDto
     */
    lastName: string;
    /**
     * Second name
     * @type {string}
     * @memberof TravelineBookingCustomerDto
     */
    middleName?: string | null;
    /**
     * Country.<br />
     * Three-letter code compliant with ISO 3166-1 alpha-3
     * @type {string}
     * @memberof TravelineBookingCustomerDto
     */
    citizenship?: string | null;
    /**
     * 
     * @type {TravelineBookingPersonContactsDto}
     * @memberof TravelineBookingCustomerDto
     */
    contacts?: TravelineBookingPersonContactsDto;
    /**
     * Guest comment to the booking<br />
     * Maximum number of characters: 250
     * @type {string}
     * @memberof TravelineBookingCustomerDto
     */
    comment?: string | null;
}

/**
 * Check if a given object implements the TravelineBookingCustomerDto interface.
 */
export function instanceOfTravelineBookingCustomerDto(value: object): value is TravelineBookingCustomerDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function TravelineBookingCustomerDtoFromJSON(json: any): TravelineBookingCustomerDto {
    return TravelineBookingCustomerDtoFromJSONTyped(json, false);
}

export function TravelineBookingCustomerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingCustomerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'citizenship': json['citizenship'] == null ? undefined : json['citizenship'],
        'contacts': json['contacts'] == null ? undefined : TravelineBookingPersonContactsDtoFromJSON(json['contacts']),
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

  export function TravelineBookingCustomerDtoToJSON(json: any): TravelineBookingCustomerDto {
      return TravelineBookingCustomerDtoToJSONTyped(json, false);
  }

  export function TravelineBookingCustomerDtoToJSONTyped(value?: TravelineBookingCustomerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'citizenship': value['citizenship'],
        'contacts': TravelineBookingPersonContactsDtoToJSON(value['contacts']),
        'comment': value['comment'],
    };
}

